import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { Quality } from '../../../app/models/Quality';
import QualityForm from './forms/QualityForm';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    quality: Quality;
    setQuality: (quality: Quality) => void;
    errorFields?: any;
}

const QualityFormContainer = ({
    fetching,
    action,
    cancel,
    quality,
    setQuality,
    errorFields = null
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <QualityForm
                        qualityDataForm={quality}
                        setQualityDataForm={setQuality}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default QualityFormContainer;
